import { render, staticRenderFns } from "./BreadDataTable.vue?vue&type=template&id=3147e4e5&scoped=true&"
import script from "./BreadDataTable.vue?vue&type=script&lang=js&"
export * from "./BreadDataTable.vue?vue&type=script&lang=js&"
import style0 from "./BreadDataTable.vue?vue&type=style&index=0&id=3147e4e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3147e4e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDataTable,VList,VListItem,VListItemTitle,VMenu,VSelect})
